import { createFileRoute } from '@tanstack/react-router';
import { QuickstartPage } from '../screens/developers/guides/QuickstartPage';

/** Public: what the API is for, a key, the five calls and the whole program in four languages. */
export const Route = createFileRoute('/developers/')({
  component: QuickstartPage,
});
